import { VATS } from './vats';

export const getVatByCountry = country => {
  const vat = VATS[country];
  if (vat) {
    return vat;
  } else {
    return 0;
  }
};

export const formatPrice = number => (+number.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 });

export const roundNumber = (number, decimals = 2) =>
  +(Math.round((number + Number.EPSILON) * 100) / 100).toFixed(decimals);

export const getFileExtensionFromBase64 = base64String => {
  // Regular expression to extract the MIME type
  const mimeTypeMatch = base64String.match(/^data:([A-Za-z-+/]+);base64,/);
  if (!mimeTypeMatch || mimeTypeMatch.length !== 2) {
    throw new Error('Invalid base64 string');
  }

  const mimeType = mimeTypeMatch[1];

  // Map MIME type to file extension
  const mimeToExtension = {
    'image/jpg': 'jpg',
    'image/jpeg': 'jpg',
    'image/png': 'png',
  };

  const extension = mimeToExtension[mimeType];
  if (!extension) {
    throw new Error('Unsupported MIME type');
  }

  return [extension, mimeType];
};

export const base64ToFile = (base64String, fileNamePrefix) => {
  const [extension, mimeType] = getFileExtensionFromBase64(base64String);
  // Decode the base64 string
  const byteString = atob(base64String.split(',')[1]);

  // Create an array of byte values
  const byteNumbers = new Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    byteNumbers[i] = byteString.charCodeAt(i);
  }

  // Create a Uint8Array from the byte array
  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob from the Uint8Array
  const blob = new Blob([byteArray], { type: mimeType }); // Adjust the MIME type as needed

  // Create a File from the Blob
  const file = new File([blob], `${fileNamePrefix}.${extension}`, { type: mimeType }); // Adjust the MIME type and file name as needed

  return file;
};

export const sanitizeUsername = username =>
  typeof username === 'string' && username.startsWith('@') ? username.slice(1) : username;

export const getInitials = (firstName = '', lastName = '') => {
  const firstInitial = firstName.trim() ? firstName.trim()[0].toUpperCase() : '';
  const lastInitial = lastName.trim() ? lastName.trim()[0].toUpperCase() : '';
  return firstInitial + lastInitial;
};

export const formatNumber = num => {
  if (num == null) return '';

  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  }

  return num.toString();
};

export const formatCurrency = amount => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const objectToFormData = obj => {
  const fd = new FormData();

  Object.entries(obj).forEach(([key, value]) => {
    // ArrayBuffer → Blob
    if (value instanceof ArrayBuffer) {
      const blob = new Blob([value], { type: 'application/octet-stream' });
      fd.append(key, blob);
      return;
    }

    // Array of strings
    if (Array.isArray(value)) {
      value.forEach(item => fd.append(key + '[]', item));
      return;
    }

    // Normal values
    fd.append(key, value);
  });

  return fd;
};

export const cropText = (text, max = 25) => {
  if (!text) return '';
  return text.length > max ? text.slice(0, max) + '...' : text;
};

export const splitByUppercase = str => {
  return str.replace(/([a-z])([A-Z])/g, '$1 $2');
};
